/**
 * Erstellt von Attribut. Zur identifikation wo Daten her kommen.
 */
export enum CreatedBy {
   /**
    * von der Verwaltung angelegt
    */
   management = "management",

   /**
    * vom Kunden angelegt
    */
   customer = "customer",

   /**
    * durch Mailings von der Verwaltung angelegt
    */
   mailingManagement = "mailingManagement",

   /**
    * durch Mailings von Kunde angelegt
    */
   mailingCustomer = "mailingCustomer",
}

export const CreatedByNames = {
   management: "Verwaltung",
   customer: "Kund:in",
   mailingManagement: "Mailings (Verwaltung)",
   mailingCustomer: "Mailings (Kund:in)"
};